import { CookiesService, HttpClient } from 'core/common/services';
import { parseQueryParams } from 'core/common/utils/getQueryParams';
import { locationCookieName } from 'core/user/constants';
import { Locales, Regions, UserLocation } from 'core/user/entities';
import { LocationService } from './LocationService';

const localeValues = new Set<string>(Object.values(Locales));

export class LocationClientService implements LocationService {
  private overriddenLocation: Partial<UserLocation> = {};
  private country = '';

  constructor(
    private readonly httpClient: HttpClient,
    private readonly cookiesService: CookiesService,
  ) {
    this.loadFromQueryParams();
  }

  getCountry() {
    return this.country;
  }

  readCookieLocation(): UserLocation | null {
    const country = this.cookiesService.get(locationCookieName);

    if (!country) {
      return null;
    }

    this.setCountry(country);

    const locale = localeValues.has(country) ? (country as Locales) : Locales.OTHER;

    return {
      locale: this.overriddenLocation.locale ?? locale,
      region: this.overriddenLocation.region ?? Regions.OTHER,
      country: this.overriddenLocation.country ?? country,
    };
  }

  async getLocation(): Promise<UserLocation> {
    try {
      const { data: location } = await this.httpClient.get<UserLocation>('/locale');

      this.setCountry(location.country);

      return {
        locale: this.overriddenLocation.locale ?? location.locale,
        region: this.overriddenLocation.region ?? location.region,
        country: this.overriddenLocation.country ?? location.country,
      };
    } catch {
      return {
        locale: Locales.OTHER,
        country: '',
        region: Regions.OTHER,
      };
    }
  }

  private setCountry(country: string) {
    this.country = country;
  }

  private loadFromQueryParams() {
    const queries = parseQueryParams<UserLocation>(window.location.search);

    this.overriddenLocation.locale = queries.locale;
    this.overriddenLocation.country = queries.country;
    this.overriddenLocation.region = queries.region;
  }
}
